import { store } from "@/store/store";
import { RouteRecordRaw, createRouter, createWebHashHistory, RouterOptions } from "vue-router";
import Home from "../views/Home.vue";
import Login from "@/views/Login.vue";
import UserList from "@/views/UserList.vue";
import PerformanceReport from "@/views/PerformanceReport.vue";
import PerformanceSummaryReport from "@/views/PerformanceSummaryReport.vue";
import ShipmentCheck from "@/views/ShipmentCheck.vue";
import MapReport from "@/views/MapReport.vue";
import NotFound from "@/views/NotFound.vue";

const routes: Readonly<RouteRecordRaw[]> = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: "/userList",
    name: "UserList",
    component: UserList,
    meta: { requiresAuth: true }
  },
  {
    path: "/performanceReport",
    name: "PerformanceReport",
    component: PerformanceReport,
    meta: { requiresAuth: true }
  },
  {
    path: "/performanceSummaryReport",
    name: "PerformanceSummaryReport",
    component: PerformanceSummaryReport,
    meta: { requiresAuth: true }
  },
  {
    path: "/mapReport",
    name: "MapReport",
    component: MapReport,
    meta: { requiresAuth: true }
  },
  {
    path: "/shipmentCheck",
    name: "ShipmentCheck",
    component: ShipmentCheck,
    meta: { requiresAuth: true }
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
    meta: { requiresAuth: false }
  }
] as const;

const routerOptions: RouterOptions = {
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  }
};

const router = createRouter(routerOptions);

router.beforeEach((to, from, next) => {
  const requiresAuth = to.meta.requiresAuth ?? true;
  
  if (store.value.token && to.name === "Login") {
    next({ name: "Home" });
  } else if (!store.value.token && requiresAuth) {
    next({ name: "Login" });
  } else {
    next();
  }
});

export default router;
